import type { FunctionComponent } from 'react';

import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

import { ICON_PROPS } from './constants';
import useJobStatus from './useJobStatus';

const JobStatus: FunctionComponent = () => {
  const { icon, title, subtitle } = useJobStatus();

  return (
    <PleaseWaitOverlay
      icon={icon}
      iconStoke={ICON_PROPS.stroke}
      title={title}
      labelLine1={subtitle}
    />
  );
};

export default JobStatus;
